
import React, { Component } from 'react';

import { FormProvider, FormContext } from 'core/FormProvider';
import Layout from 'components/Dashboard/Layout';
import { YellowButton } from 'ui/Button';
import { UserContext } from 'components/User';
import { TractorUnitForm } from './Form';


export default class TractorUnitAdd extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Новое ТС';
  }

  onDetail = () => {
    this.props.history.push(`/tractor_unit`);
  };

  render() {
    return (
      <FormProvider
        url={'fleet/truck'}
        postSave={(item) => this.onDetail(item)}
        postSaveMessage={'ТС добавлено'}
        item={{
          department: this.context.data.department_active,
          is_active: true
        }}
      >
        <FormContext.Consumer>
        {context => {
          const { loading } = context;
          return (
            <Layout>
              <Layout.Header
                title={'Создание ТС'}
                backUrl={'/tractor_unit'}
              />

              <Layout.ContentSimple>
                <TractorUnitForm />

                <div className={'mt-30'}>
                  <YellowButton
                    onClick={(e) => context.handleSubmit(e)}
                    size={'large'}
                    disabled={loading}
                  >
                    Создать ТС
                  </YellowButton>
                </div>
              </Layout.ContentSimple>
            </Layout>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
